const urlMapping = {
  // ["登录"]: "/api/administrator/login",
  ["注销"]: "/api/shared/logout",

  /****************评论****************/
  ["查询评论"]: "/api/administrator/comment/queryComment",
  ["回复评论"]: "/api/administrator/comment/replyComment",
  ["删除评论"]: "/api/administrator/comment/deleteComment",

  ["查询未读评论"]: "/api/administrator/comment/queryUnreadComment",
  ["评论置已读"]: "/api/administrator/comment/setCommentRead",

  // /****************评论****************/
  // ["加盟商查询评论"]: "/api/vendor/comment/queryComment",
  // ["加盟商回复评论"]: "/api/vendor/comment/replyComment",
  // ["加盟商删除评论"]: "/api/vendor/comment/deleteComment",

  /****************管理员****************/
  ["查询管理员"]: "/api/administrator/getAdministrator",
  ["新增管理员"]: "/api/administrator/saveAdministrator",
  ["删除管理员"]: "/api/administrator/deleteAdministrator",
  ["编辑管理员"]: "/api/administrator/updateAdministrator",

  /****************订单****************/
  ["查询订单"]: "/api/administrator/order/getOrders",
  ["下载订单"]: "/api/administrator/order/downloadOrders",

  // /****************加盟商订单****************/
  // ["加盟商查询订单"]: "/api/vendor/order/getOrders",
  // ["加盟商下载订单"]: "/api/vendor/order/downloadOrders",

  /****************加盟商订单****************/
  ["新增广告"]: "/api/administrator/advertisement/save",
  ["删除广告"]: "/api/administrator/advertisement/deleteAdvertisement",
  ["编辑广告"]: "/api/administrator/advertisement/updateAdvertisement",
  ["查询广告"]: "/api/administrator/advertisement/getAdvertisement",

  /****************门店****************/
  ["查询门店"]: "/api/administrator/shop/getShopsByPages",
  ["查询门店提示"]: "/api/administrator/shop/queryShopForPrompt",
  ["新增门店"]: "/api/administrator/shop/saveShop",
  ["编辑门店"]: "/api/administrator/shop/updateShopInfoByShopID",
  ["删除门店"]: "/api/administrator/shop/deleteByShopIDs",

  /****************加盟商****************/
  ["查询加盟商"]: "/api/administrator/vendor/queryVendor",
  ["查询加盟商提示"]: "/api/administrator/vendor/queryVendorForPrompt",
  ["新增加盟商"]: "/api/administrator/vendor/addVendor",
  ["删除加盟商"]: "/api/administrator/vendor/deleteByVendorids",
  ["编辑加盟商"]: "/api/administrator/vendor/updateVendor",
  // ["加盟商登录"]: "/api/vendor/login",
  // [""]: "/api/shared/logout",
  ["修改密码"]: "/api/administrator/changePassword",

  /****************子账号****************/
  ["子账号查询"]: "/api/administrator/subAgentVendorAccountApi/query",
  ["子账号添加"]: "/api/administrator/subAgentVendorAccountApi/add",
  ["子账号删除"]: "/api/administrator/subAgentVendorAccountApi/delete",

  /****************项目****************/
  // ["查询项目"]: "/api/administrator/project/getProjects",
  // ["新增项目"]: "/api/administrator/project/saveProject",
  // ["删除项目"]: "/api/administrator/project/deleteByProjectIDs",
  // ["编辑项目"]: "/api/administrator/project/updateProject",

  /****************产品****************/
  ["查询产品"]: "/api/administrator/product/getProductsByPages",
  ["查询产品详情"]: "/api/administrator/product/getProductsByProductIDs",
  ["新增产品"]: "/api/administrator/product/saveProduct",
  // ["删除产品"]: "/api/administrator/product/deleteByProductIDs",
  ["编辑产品"]: "/api/administrator/product/updateProduct",
  ["产品上下线"]: "/api/administrator/product/setDisabledProductsByProductIDs",

  /****************加盟商产品****************/
  // ["加盟商查询产品"]: "/api/vendor/product/getProductsByPages",
  // ["加盟商查询产品详情"]: "/api/vendor/product/getProductsByProductIDs",
  // ["加盟商新增产品"]: "/api/vendor/product/saveProduct",
  // // ["删除产品"]: "/api/administrator/product/deleteByProductIDs",
  // ["加盟商编辑产品"]: "/api/vendor/product/updateProduct",
  // ["加盟商产品上下线"]: "/api/vendor/product/setDisabledProductsByProductIDs",

  /****************机器****************/
  ["查询机器"]: "/api/administrator/machine/getMachine",
  //["查询机器型号列表"]: "/api/shared/getMachineModelInfo",
  ["新增机器"]: "/api/administrator/machine/saveMachine",
  ["删除机器"]: "/api/administrator/machine/deleteMachine",
  ["编辑机器"]: "/api/administrator/machine/updateMachine",

  ["查询加液器"]: "/api/administrator/liquidfeeder/getLiquidFeeder",
  ["新增加液器"]: "/api/administrator/liquidfeeder/saveLiquidFeeder",
  ["删除加液器"]: "/api/administrator/liquidfeeder/deleteLiquidFeeder",
  ["编辑加液器"]: "/api/administrator/liquidfeeder/updateLiquidFeeder",
  ["操作加液器"]: "/api/administrator/liquidfeeder/operateLiquidFeeder",
  ["查询加液器状态"]: "/api/administrator/liquidfeeder/LiquidFeederGetStatus",

  // ["测试自研加液器"]: "/api/administrator/liquidfeeder/sendZiyanLiquidFeederCommand",
  ["测试自研加液器API"]:
    "/api/administrator/liquidfeeder/sendZiyanLiquidFeederWithApi",

  ["测试自研加液器重启"]:
    "/api/administrator/liquidfeeder/setZiyanLiquidFeederReset",
  ["测试自研加液器设置语言"]:
    "/api/administrator/liquidfeeder/setZiyanLiquidFeederLanguage",
  ["测试自研加液器设置模式"]:
    "/api/administrator/liquidfeeder/setZiyanLiquidFeederRemoteMode",
  ["测试自研加液器设置通道屏显毫升数"]:
    "/api/administrator/liquidfeeder/setZiyanLiquidFeederDisplayBatch",
  ["测试自研加液器设置通道显示内容"]:
    "/api/administrator/liquidfeeder/setZiyanLiquidFeederDisplayItemBatch",

  ["批量停启机器"]: "/api/administrator/machine/setMachineEnable",
  ["查询机器故障"]: "/api/administrator/machine/getMachineTrouble",
  ["新增机器故障"]: "/api/administrator/machine/saveMachineTrouble",
  ["设置报障已读"]: "/api/administrator/machine/setMachineTroubleRead",
  ["操作机器"]: "/api/administrator/machine/operateMachine",
  ["心跳设置"]: "/api/administrator/machine/resetReportInterval",
  ["上报消息查询"]: "/api/administrator/machine/getZhuoyiNotify",
  ["上报消息查询Out"]: "/api/administrator/machine/getZhuoyiNotifyOut",
  ["查询离线"]: "/api/administrator/machine/getMachineOfflineLog",

  ["查询机器联动"]: "/api/shared/getAllMachineModelInfoList",
  ["设置协议"]: "/api/administrator/machine/setMachineSystem",
  ["初始化盒子"]: "/api/administrator/machine/initMachineSystemBeiEr",
  ["发送产品指令"]: "/api/administrator/machine/sendCommandWithProductid",
  ["查询洗衣液"]: "/api/administrator/machine/getMachineLiquidUsageInfo",
  ["加液归零"]: "/api/administrator/machine/clearMachineLiquidUsageCount",

  /****************支付****************/
  ["查询支付信息"]: "/api/administrator/payment/getPayment",

  /****************用户****************/
  ["查询用户"]: "/api/administrator/user/getUsers",
  ["禁止用户"]: "/api/administrator/user/disableUsers",

  /****************余额查询****************/
  ["查询余额"]: "/api/administrator/deposit/queryRemain",
  ["查询余额记录"]: "/api/administrator/deposit/queryDepositUseLog",

  /****************日志****************/
  ["查询日志"]: "/api/administrator/logbusiness/getLogBusiness",
  /****************退款****************/
  ["查询退款"]: "/api/administrator/refund/getRefunds",
  ["退款审核"]: "/api/administrator/refund/auditRefunds",
  ["设置退款备注"]: "/api/administrator/refund/setRefundsRemark",
  ["设置拒绝原因备注"]: "/api/administrator/refund/setDenyReason",
  ["下载退款列表"]: "/api/administrator/refund/downloadRefunds",
  ["查询退款率"]: "/api/administrator/refund/getRefundRate",

  ["查询退款对话"]: "/api/administrator/refund/getRefundComment",
  ["保存退款对话"]: "/api/administrator/refund/saveRefundComment",
  ["退款对话设置已读"]: "/api/administrator/refund/setRefundRead",

  /****************统计****************/
  ["查询全量每日订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByDaily",
  ["查询全量每小时订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByHourly",
  ["查询全量每月订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByMonthly",
  ["查询全量每日订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByDaily",
  ["查询全量每小时订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByHourly",
  ["查询全量每月订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByMonthly",

  ["查询城市每日订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByCityDaily",
  ["查询城市每小时订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByCityHourly",
  ["查询城市每月订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByCityMonthly",

  ["查询门店每日订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByShopDaily",
  ["查询门店每小时订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByShopHourly",
  ["查询门店每月订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByShopMonthly",

  ["查询加盟商每日订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByVendorDaily",
  ["查询加盟商每小时订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByVendorHourly",
  ["查询加盟商每月订单金额"]:
    "/api/administrator/statistics/getOrderReportAmountByVendorMonthly",

  ["查询城市每日订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByCityDaily",
  ["查询城市每小时订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByCityHourly",
  ["查询城市每月订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByCityMonthly",

  ["查询门店每日订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByShopDaily",
  ["查询门店每小时订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByShopHourly",
  ["查询门店每月订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByShopMonthly",

  ["查询加盟商每日订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByVendorDaily",
  ["查询加盟商每小时订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByVendorHourly",
  ["查询加盟商每月订单总量"]:
    "/api/administrator/statistics/getOrderReportCountByVendorMonthly",

  ["根据状态查询机器"]: "/api/administrator/machine/getMachineByStatus",
  ["查询机器使用次数"]:
    "/api/administrator/statistics/getMachineUseCountStatistic",

  ["查询机器状态统计值"]:
    "/api/administrator/statistics/getMachineStatusStatistic",
  ["查询禁用机器数"]: "/api/administrator/statistics/getDisabledMachineCount",
  ["查询简单订单统计"]: "/api/administrator/statistics/getSimpleOrderStatistic",
  ["查询账单统计"]: "/api/administrator/dailybill/statisticDailyBill",
  ["查询门店排名"]: "/api/administrator/statistics/getShopRank",
  ["查询用户增长"]: "/api/administrator/statistics/getUserGrowth",

  /****************优惠券****************/
  ["新增优惠券"]: "/api/administrator/coupon/createCoupon",
  ["删除优惠券"]: "/api/administrator/coupon/deleteCoupon",
  ["查询优惠券"]: "/api/administrator/coupon/queryCoupon",
  ["更新优惠券"]: "/api/administrator/coupon/updateCoupon",
  ["分配优惠券"]: "/api/administrator/coupon/bindCouponToUsers",
  ["查询用户的优惠券"]: "/api/administrator/coupon/queryUserCoupon",
  ["删除用户的优惠券"]: "/api/administrator/coupon/deleteCouponsFromUser",
  ["查询补券的优惠券"]: "/api/administrator/coupon/queryBuquanCoupon",
  ["查询独特优惠券"]: "/api/administrator/coupon/queryUniqueCouponUserRelation",
  ["删除独特优惠券"]:
    "/api/administrator/coupon/deleteUniqueCouponUserRelation",
  ["分配独特优惠券"]: "/api/administrator/coupon/bindUniqueCouponToUser",
  /****************账单****************/
  ["查询账单"]: "/api/administrator/dailybill/queryDailyBill",
  ["查询账单总和"]: "/api/administrator/dailybill/queryDailyBillSum",
  ["下载账单"]: "/api/administrator/dailybill/downloadDailyBill",
  ["查询VIP卡账单"]: "/api/administrator/dailyVipBill/queryVipBill",
  ["查询VIP卡账单总和"]: "/api/administrator/dailyVipBill/queryVipBillSum",
  ["下载VIP卡账单"]: "/api/administrator/dailyVipBill/downloadDailyVipBill",

  /****************发票*************** */
  ["查询发票申请"]: "/api/administrator/receipt/getReceipt",
  ["审核发票"]: "/api/administrator/receipt/updateReceiptStatus",
  /****************提现****************/
  ["查询提现申请"]: "/api/administrator/withdrawCash/queryWithdrawCashList",
  ["提现审核"]: "/api/administrator/withdrawCash/auditWithdrawCash",
  ["保存提现备注"]: "/api/administrator/withdrawCash/saveRemark",

  /****************VIP****************/
  ["新增VIP"]: "/api/administrator/vipcard/createVipcard",
  ["删除VIP"]: "/api/administrator/vipcard/deleteVipcard",
  ["查询VIP"]: "/api/administrator/vipcard/queryVipcard",
  ["更新VIP"]: "/api/administrator/vipcard/updateVipcard",
  ["分配VIP"]: "/api/administrator/vipcard/bindVipcardToUsers",
  ["查询用户的Vip卡"]: "/api/administrator/vipcard/queryVipcardByUsername",
  ["查询vip卡用户关系"]: "/api/administrator/vipcard/queryVipcardUserRelation",
  ["删除用户VIP关联"]: "/api/administrator/vipcard/deleteVipcardUserRelation",

  /****************scheduledPromotion****************/
  ["新增定时促销"]:
    "/api/administrator/scheduledPromotion/createScheduledPromotion",
  ["删除定时促销"]:
    "/api/administrator/scheduledPromotion/deleteScheduledPromotion",
  ["查询定时促销"]:
    "/api/administrator/scheduledPromotion/queryScheduledPromotion",
  ["更新定时促销"]:
    "/api/administrator/scheduledPromotion/updateScheduledPromotion",

  /****************代理商****************/
  ["新增代理商"]: "/api/administrator/agent/addAgent",
  ["查询代理商提示"]: "/api/administrator/agent/queryAgentForPrompt",
  ["删除代理商"]: "/api/administrator/agent/deleteByAgentids",
  ["查询代理商"]: "/api/administrator/agent/queryAgent",
  ["编辑代理商"]: "/api/administrator/agent/updateAgent",

  /****************productTemplate****************/
  ["查询产品模板"]: "/api/shared/getProductTemplatesByPages",
  ["查询模板绑定"]: "/api/shared/getProductsByShopidAndMachineModel",
  ["查询产品模板详情"]: "/api/shared/getProductTemplatesByTemplateIDs",
  ["新增产品模板"]: "/api/administrator/productTemplate/saveProductTemplate",
  ["编辑产品模板"]: "/api/administrator/productTemplate/updateProductTemplate",
  ["删除产品模板"]:
    "/api/administrator/productTemplate/deleteProductTemplateByTemplateid",

  /****************product****************/
  ["获取产品信息"]: "/api/administrator/product/getProductInfoByPages",
  ["获取产品信息Byid"]: "/api/administrator/product/getProductsByProductIDs",
  ["保存产品"]: "/api/administrator/product/saveProduct",
  ["设置失效产品"]:
    "/api/administrator/product/setDisabledProductsByProductIDs",
  ["更新产品"]: "/api/administrator/product/updateProduct",
  ["删除产品"]: "/api/administrator/product/deleteProductsByProductIds",
  ["机器的产品"]: "/api/administrator/product/getProductsListByMachineID",
  ["批量设置产品"]: "/api/administrator/product/batchSaveProducts",

  /****************查询全局数据****************/
  ["查询代理商IDName"]: "/api/shared/getAllAgentIDName",
  ["查询加盟商IDName"]: "/api/shared/getAllVendorIDName",
  ["查询门店IDName"]: "/api/shared/getAllShopIDName",
  ["获取验证码"]: "/api/shared/getCaptcha",
  ["生成支付宝二维码"]: "/api/shared/createZhifubaoQrcode"
};

export default urlMapping;
